import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/Search/SearchStore.ts";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.values.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { combine, createEvent, restore, forward, sample, merge, createStore } from 'effector';
import * as api from '@gmini/sm-api-sdk';
import { isNotEmpty } from '@gmini/utils';
import { clone } from 'ramda';
import { getNode } from "../../classifier-service";
import { adapter } from "../../classifier-service/adapters";
import { buildTreeItemKey } from "../ClassifierTree/buildTreeItemKey";
import { findFlatNodeByKey } from "../ClassifierTree/utils";
import { isApiFlatNode } from "../ClassifierTree/createTree";
import { executeNodeSearchPending } from "./search.model";
import { createNodeSearchModel, getBimNode } from "./utils";
export function createSearchNodeModel(_ref) {
  var nodes$ = _ref.nodes$,
      tree$ = _ref.tree$,
      currentEntity$ = _ref.currentEntity$,
      searchInDynamicGroups = _ref.searchInDynamicGroups;
  var setSearchNodes = createEvent({
    name: "setSearchNodes",
    sid: "-96z986"
  });
  var isolate = createEvent({
    name: "isolate",
    sid: "-5i3sfr"
  });
  var searchByNodeRef = createEvent({
    name: "searchByNodeRef",
    sid: "-agf8bz"
  });
  var resetSearchNodes = createEvent({
    name: "resetSearchNodes",
    sid: "v7nudy"
  });
  var searchNodes$ = createStore(null, {
    name: "searchNodes$",
    sid: "71jy6x"
  }).on(setSearchNodes, function (state, result) {
    return result;
  }).on(isolate, function (state, isolated) {
    return state ? _objectSpread(_objectSpread({}, state), {}, {
      isolated: isolated
    }) : null;
  }).reset(resetSearchNodes);
  api.UserClassifier.getElementFromViewer.defaultContext.doneData.map(adapter).watch(function (element) {
    return setSearchNodes({
      type: 'search',
      nodes: [{
        path: [],
        node: element
      }]
    });
  }); // Закомментил временно в рамках задачи GT-3270
  // sample({
  //   clock: setSearchNodes,
  //   source: combine({ currentEntity: currentEntity$, nodes: nodes$ }),
  //   fn: ({ currentEntity, nodes }, searchNodes) => ({
  //     currentEntity,
  //     nodes,
  //     searchNodes: searchNodes?.nodes || [],
  //     refIds: searchNodes?.type === 'filter' ? searchNodes?.refIds : [],
  //   }),
  // }).watch(({ currentEntity, nodes, searchNodes, refIds }) => {
  //   searchNodes.forEach(({ node }) => {
  //     const bimElementNode = getBimNode(node, nodes)
  //     if (currentEntity && bimElementNode?.type === 'BimElementNode') {
  //       const { id, version } = currentEntity
  //       const sourceUserCls = currentEntity.sourceClassifiers
  //         .filter(ref => ref.type === 'UserClassifierNode')
  //         .map(ref => {
  //           const node = getNode(nodes, ref)
  //           return node
  //             ? { classifierId: node.id, classifierVersion: node.version }
  //             : null
  //         })
  //         .filter(isNotEmpty)
  //       api.UserClassifier.fetchElementRefs.defaultContext.submit({
  //         elementId: node.id,
  //         classifiers: [
  //           { classifierId: id, classifierVersion: version },
  //           ...sourceUserCls,
  //         ],
  //       })
  //     }
  //   })
  // })

  var resetSearchedRefs = merge([api.UserClassifier.fetchElementRefs.trigger, resetSearchNodes], {
    name: "resetSearchedRefs",
    sid: "k09cl5"
  });
  var searchedRefs$ = restore(api.UserClassifier.fetchElementRefs.defaultContext.doneData.map(function (_ref2) {
    var items = _ref2.items;
    return items.map(adapter);
  }), null, {
    name: "searchedRefs$",
    sid: "d174l8"
  }).reset(resetSearchedRefs);
  var searchedGroups$ = createStore(null, {
    name: "searchedGroups$",
    sid: "ml12eq"
  }).on(api.UserClassifier.findAllElementsByFilter.defaultContext.doneData, function (_, _ref3) {
    var elements = _ref3.elements;
    return _toConsumableArray(new Set(elements.flatMap(function (el) {
      return el.parentDynamicGroupIds;
    })));
  }).reset(api.UserClassifier.findAllElementsByFilter.defaultContext.done);
  var fetchParentDynamicGroups = createEvent({
    name: "fetchParentDynamicGroups",
    sid: "ejbeb4"
  });
  var parentDynamicGroups$ = combine({
    ɔ: [{
      nodes: nodes$,
      searchedGroups: searchedGroups$
    }, function (_ref4) {
      var nodes = _ref4.nodes,
          searchedGroups = _ref4.searchedGroups;

      if (searchedGroups !== null && searchedGroups !== void 0 && searchedGroups.length) {
        return searchedGroups.map(function (id) {
          return nodes.DynamicGeneratedGroupNode[id];
        }).filter(isNotEmpty);
      }

      return null;
    }],
    config: {
      name: "parentDynamicGroups$",
      sid: "-7l6ssd"
    }
  });
  forward({
    ɔ: {
      from: api.UserClassifier.getElementFromViewer.defaultContext.fail,
      to: resetSearchNodes
    },
    config: {
      sid: "9u1mo5"
    }
  });
  sample({
    ɔ: [{
      source: combine({
        ɔ: [{
          nodes: nodes$,
          tree: tree$
        }],
        config: {
          name: "source",
          sid: "7g7ltt"
        }
      }),
      clock: searchByNodeRef,
      fn: function fn(_ref5, nodeRef) {
        var nodes = _ref5.nodes,
            tree = _ref5.tree;
        return {
          node: getNode(nodes, nodeRef),
          tree: tree
        };
      }
    }],
    config: {
      sid: "9wslmy"
    }
  }).watch(function (_ref6) {
    var node = _ref6.node,
        tree = _ref6.tree;

    if (!node) {
      return;
    }

    var flatNode = findFlatNodeByKey(buildTreeItemKey(node), tree);
    setSearchNodes({
      type: 'search',
      nodes: [{
        node: node,
        path: (flatNode === null || flatNode === void 0 ? void 0 : flatNode.path) || []
      }]
    });
  });
  var searchMatched$ = combine({
    ɔ: [{
      searchNodes: searchNodes$,
      tree: tree$,
      nodes: nodes$,
      searchedRefs: searchedRefs$,
      parentDynamicGroups: parentDynamicGroups$
    }, function (_ref7) {
      var _searchNodes$nodes;

      var searchNodes = _ref7.searchNodes,
          tree = _ref7.tree,
          nodes = _ref7.nodes,
          searchedRefs = _ref7.searchedRefs,
          parentDynamicGroups = _ref7.parentDynamicGroups;

      if (!tree.length || !(searchNodes !== null && searchNodes !== void 0 && (_searchNodes$nodes = searchNodes.nodes) !== null && _searchNodes$nodes !== void 0 && _searchNodes$nodes.length)) {
        return {};
      }

      var nodeSearchModel = createNodeSearchModel(nodes, tree, buildTreeItemKey);
      return searchNodes.nodes.reduce(function (searchMap, _ref8) {
        var node = _ref8.node;
        var nextSearchMap = clone(searchMap);
        var bimNode = getBimNode(node, nodes);

        if (!bimNode || !node) {
          return nextSearchMap;
        }

        var assemblyExists = tree.filter(isApiFlatNode).some(function (_ref9) {
          var _node$assemblyModelRe, _getNode;

          var ref = _ref9.ref,
              path = _ref9.path;
          var node = getNode(nodes, ref);
          return path.length === 1 && (node === null || node === void 0 ? void 0 : node.type) === 'AssemblyClassifierNode' && (node === null || node === void 0 ? void 0 : (_node$assemblyModelRe = node.assemblyModelRef) === null || _node$assemblyModelRe === void 0 ? void 0 : _node$assemblyModelRe.type) === 'BimModelReferenceNode' && ((_getNode = getNode(nodes, node.assemblyModelRef.element)) === null || _getNode === void 0 ? void 0 : _getNode.modelType) === 'AssemblyModel';
        });

        if (bimNode.type === 'BimElementNode') {
          var standardSizeNode = nodes.BimStandardSizeNode[bimNode.standardSizeId];

          if (!standardSizeNode) {
            return nextSearchMap;
          }

          if (assemblyExists) {
            nextSearchMap = _objectSpread(_objectSpread({}, nextSearchMap), nodeSearchModel.searchAssemblyElementNode(bimNode, standardSizeNode));
          }

          if (searchInDynamicGroups && parentDynamicGroups !== null && parentDynamicGroups !== void 0 && parentDynamicGroups.length) {
            nextSearchMap = _objectSpread(_objectSpread({}, nextSearchMap), nodeSearchModel.searchInParentDynamicGroupNode(bimNode, parentDynamicGroups));
          }

          var matchedElements = nodeSearchModel.searchElementNode(bimNode, standardSizeNode, searchedRefs);
          return _objectSpread(_objectSpread({}, nextSearchMap), matchedElements);
        }

        if (assemblyExists) {
          var matchedNodes = nodeSearchModel.searchAssemblyModelElementNode(bimNode);
          nextSearchMap = _objectSpread(_objectSpread({}, nextSearchMap), matchedNodes);
        }

        if (searchInDynamicGroups) {
          var dynamicGroups = Object.values(nodes.DynamicGeneratedGroupNode);
          var dynamicGroupMap = nodeSearchModel.searchInDynamicGroupNodes(bimNode, dynamicGroups);
          nextSearchMap = _objectSpread(_objectSpread({}, nextSearchMap), dynamicGroupMap);
        }

        return _objectSpread(_objectSpread({}, nextSearchMap), nodeSearchModel.searchModelElementNode(bimNode));
      }, {});
    }],
    config: {
      name: "searchMatched$",
      sid: "jm8wn1"
    }
  });

  function filterTree(tree$) {
    return combine({
      ɔ: [{
        tree: tree$,
        searchMatched: searchMatched$,
        searchNodes: searchNodes$
      }, function (_ref10) {
        var tree = _ref10.tree,
            searchMatched = _ref10.searchMatched,
            searchNodes = _ref10.searchNodes;

        if ((searchNodes === null || searchNodes === void 0 ? void 0 : searchNodes.type) === 'filter' && searchNodes !== null && searchNodes !== void 0 && searchNodes.isolated) {
          var filteredTree = tree.filter(function (_ref11) {
            var path = _ref11.path,
                ref = _ref11.ref;
            return ref.type === 'LoadMore' || searchMatched[path[path.length - 1]];
          });
          return filteredTree;
        }

        return tree;
      }],
      config: {
        sid: "qu24gs"
      }
    });
  }

  return {
    setSearchNodes: setSearchNodes,
    resetSearchNodes: resetSearchNodes,
    isolate: isolate,
    searchNodes$: searchNodes$,
    executeNodeSearchPending: executeNodeSearchPending,
    searchMatched$: searchMatched$,
    searchByNodeRef: searchByNodeRef,
    fetchParentDynamicGroups: fetchParentDynamicGroups,
    filterTree: filterTree
  };
}